import { useTranslation } from "react-i18next";

export function useLanguage() {
  const { i18n } = useTranslation();

  const changeLanguage = (language: "es" | "en") => {
    i18n.changeLanguage(language);
    localStorage.setItem("preferred-language", language);
  };

  return {
    currentLanguage: i18n.language as "es" | "en",
    changeLanguage,
  };
}